import { Typography, DocsIcon, FeedbackIcon, LinkGoToIcon } from 'components/UI'

const LinksSidebar = () => (
	<div class='border-t border-solid border-t-black-800 p-5'>
		<ul>
			<li class='group flex cursor-pointer items-center justify-between space-x-2 rounded px-2.5 py-2.5 text-black-200 hover:bg-black-800 hover:text-black-100'>
				<a
					aria-label='Código Documentation'
					class='flex flex-1 items-center justify-between'
					href='https://docs.codigo.ai/'
					rel='noopener noreferrer'
					target='_blank'
				>
					<div class='flex items-center'>
						<DocsIcon />
						<Typography
							class='ml-3'
							color='text-black-200 group-hover:text-black-100'
							text='Docs'
							variant='text2'
						/>
					</div>
					<LinkGoToIcon />
				</a>
			</li>

			<li class='group flex cursor-pointer items-center justify-between rounded px-2.5 py-2.5 text-black-200 hover:bg-black-800 hover:text-black-100'>
				<a
					aria-label='Feedback'
					class='flex flex-1 items-center justify-between'
					href='https://x.com/CodigoPlatform'
					rel='noopener noreferrer'
					target='_blank'
				>
					<div class='flex items-center'>
						<FeedbackIcon />
						<Typography
							class='ml-3'
							color='text-black-200 group-hover:text-black-100'
							text='Feedback'
							variant='text2'
						/>
					</div>
					<LinkGoToIcon />
				</a>
			</li>
		</ul>
	</div>
)

export { LinksSidebar }
